/**
 * @param {string} url
 * @returns {Promise.<SVGElement>}
 */
async function fetchSvg(url) {
  const response = await fetch(url)
  if (!response.ok) {
    throw new Error('Failed to fetch SVG XML: ' + url)
  }
  const xml = await response.text()
  const parser = new DOMParser()
  const parsed = parser.parseFromString(xml, 'image/svg+xml')
  return parsed.documentElement
}

/**
 * @param {SVGElement} svgEl
 * @returns {string[]}
 */
function gatherSymbolIds(svgEl) {
  const ids = []
  for (let symbolEl of svgEl.getElementsByTagName('symbol')) {
    ids.push(symbolEl.id)
  }
  return ids
}

module.exports = {
  fetchSvg,
  gatherSymbolIds
}
